/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-webapp API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.51
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DbChange
 */
export interface DbChange {
    /**
     * 
     * @type {string}
     * @memberof DbChange
     */
    statement?: string;
}

/**
 * Check if a given object implements the DbChange interface.
 */
export function instanceOfDbChange(value: object): value is DbChange {
    return true;
}

export function DbChangeFromJSON(json: any): DbChange {
    return DbChangeFromJSONTyped(json, false);
}

export function DbChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DbChange {
    if (json == null) {
        return json;
    }
    return {
        
        'statement': json['statement'] == null ? undefined : json['statement'],
    };
}

export function DbChangeToJSON(value?: DbChange | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'statement': value['statement'],
    };
}

